import { getInquiryListApi } from '@/api/procure/inquiry'
import { whetherDict } from '@/dictionary/project/common'
import { startInquiryReviewApi } from '@/api/procure/inquiry-review'

function useReviewOnlineInquiry() {
  /**
   * 获取评审采购单分页列表
   */
  const getOrderPage = params => {
    return new Promise((resolve, reject) => {
      const tempParams = Object.assign({}, params, {
        isOnlineReview: whetherDict.YES.value,
        filterStatusJoin: '-1,0'
      })
      getInquiryListApi(tempParams)
        .then(res => {
          resolve(res.data || {})
        })
        .catch(err => reject(err))
    })
  }

  /**
   * 开启打分
   */
  const openReview = ({ reviewId, orderId, isReviewerScore }) => {
    return new Promise((resolve, reject) => {
      startInquiryReviewApi(reviewId, { orderId }, { isReviewerScore })
        .then(() => resolve())
        .catch(err => reject(err))
    })
  }

  return {
    getOrderPage,
    openReview
  }
}

export default useReviewOnlineInquiry
